import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { getUserProfile, IUserProfileResponse } from '~~apis/UserService';

// Define a type for the slice state
interface UserState {
  loading: boolean,
  profile: {
    loading: boolean,
    data: IUserProfileResponse,
  },
}

// Define the initial state using that type
const initialState: UserState = {
  loading: false,
  profile: {
    loading: false,
    data: {
      email: '',
      need_reset_password: false,
      phone: '',
      profile_photo: '',
      web_user_name: '',
    },
  },
};

export const getProfile = createAsyncThunk(
  'user/getProfile',
  () => getUserProfile(),
);

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setLoaderVisible: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    clearUser: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getProfile.pending, (state) => {
      state.profile.loading = true;
    });
    builder.addCase(getProfile.fulfilled, (state, action) => {
      if (action.payload) {
        state.profile.loading = false;
        state.profile.data = action.payload;
      }
    });
  },
});

export const { setLoaderVisible, clearUser } = userSlice.actions;

export default userSlice.reducer;
